<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--login">
            <section class="l-content-area">
                <div class="l-content">


                    <section class="p-bloc p-bloc--register">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">

                                <div class="login-box">

                                    <div class="p-login__title">
                                        <div class="logo"><img src="@/assets/img/login/logo.png" alt="hubsynch"></div>
                                        <h1>{{ $t('LABEL_MERCHANT_TERM_OF_USE') }}</h1>
                                    </div>

                                    <!-- agreement -->
                                    <section class="p-agreement">
                                        <p v-html="$t('TEXT_REGISTER_AGREEMENTS_1')"></p>

                                        <div class="p-agreement__kiyaku">
                                            <div class="kiyaku-box p-kiyaku__txt">
                                                <h2>{{ $t('TEXT_REGISTER_AGREEMENTS_2') }}</h2>
                                                <p>{{ $t('TEXT_TERMS_OF_USE_1') }}</p>
                                                <p>{{ $t('TEXT_TERMS_OF_USE_2') }}</p>
                                                <h3>{{ $t('TEXT_TERMS_OF_USE_3') }}</h3>
                                                <p>{{ $t('TEXT_TERMS_OF_USE_4') }}</p>
                                                <ol>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_5') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_6') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_7') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_8') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_TERMS_OF_USE_9') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_10') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_11') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_12') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_TERMS_OF_USE_13') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_14') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_15') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_16') }}</li>
                                                    <li>{{ $t('TEXT_REGISTER_AGREEMENTS_3') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_17') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_18') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_19') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_4') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_28') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_29') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_5') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_31') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_32') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_33') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_6') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_REGISTER_AGREEMENTS_7') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_36') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_37') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_8') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_40') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_41') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_42') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_43') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_44') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_9') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_46') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_47') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_10') }}</h3>
                                                <p>{{ $t('TEXT_TERMS_OF_USE_49') }}</p>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_11') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_51') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_52') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_12') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_54') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_55') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_56') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_57') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_13') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_59') }}
                                                        <ol class="paren">
                                                            <li>{{ $t('TEXT_TERMS_OF_USE_60') }}</li>
                                                            <li>{{ $t('TEXT_TERMS_OF_USE_61') }}</li>
                                                            <li>{{ $t('TEXT_TERMS_OF_USE_62') }}</li>
                                                            <li>{{ $t('TEXT_TERMS_OF_USE_63') }}</li>
                                                            <li>{{ $t('TEXT_TERMS_OF_USE_64') }}</li>
                                                            <li>{{ $t('TEXT_TERMS_OF_USE_65') }}</li>
                                                            <li>{{ $t('TEXT_TERMS_OF_USE_66') }}</li>
                                                            <li>{{ $t('TEXT_TERMS_OF_USE_67') }}</li>
                                                            <li>{{ $t('TEXT_TERMS_OF_USE_68') }}</li>
                                                            <li>{{ $t('TEXT_TERMS_OF_USE_69') }}</li>
                                                            <li>{{ $t('TEXT_TERMS_OF_USE_70') }}</li>
                                                        </ol>
                                                    </li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_71') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_72') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_14') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_REGISTER_AGREEMENTS_15') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_77') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_16') }}</h3>
                                                <ol>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_79') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_80') }}</li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_81') }}</li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_17') }}</h3>
                                                <ol>
                                                    <li v-html="$t('TEXT_REGISTER_AGREEMENTS_18')"></li>
                                                    <li v-html="$t('TEXT_TERMS_OF_USE_85')"></li>
                                                    <li v-html="$t('TEXT_TERMS_OF_USE_86')"></li>
                                                    <li>{{ $t('TEXT_TERMS_OF_USE_87') }}<br>{{
                                                        $t('TEXT_TERMS_OF_USE_88') }}<br>{{ $t('TEXT_TERMS_OF_USE_89')
                                                        }}<br><a href="http://www.google.com/analytics"
                                                            target="_blank">http://www.google.com/analytics</a></li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_19') }}</h3>
                                                <p>{{ $t('TEXT_TERMS_OF_USE_91') }}</p>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_20') }}</h3>
                                                <p>{{ $t('TEXT_TERMS_OF_USE_93') }}</p>
                                                <p class="right-side" v-html="$t('TEXT_REGISTER_AGREEMENTS_21')"></p>
                                                <h2>{{ $t('TEXT_REGISTER_AGREEMENTS_22') }}</h2>
                                                <p>{{ $t('TEXT_PERSONAL_INFORMATION_1') }}<a target="_brank"
                                                        href="https://hubsynch.com/privacypolicy">こちら</a>をご覧ください。</p>
                                                <h3>{{ $t('TEXT_PERSONAL_INFORMATION_4') }}</h3>
                                                <p v-html="$t('TEXT_PERSONAL_INFORMATION_5')"></p>
                                                <h3>{{ $t('TEXT_PERSONAL_INFORMATION_6') }}</h3>
                                                <p v-html="$t('TEXT_PERSONAL_INFORMATION_7')"></p>
                                                <h3>{{ $t('TEXT_PERSONAL_INFORMATION_8') }}</h3>
                                                <p v-html="$t('TEXT_REGISTER_AGREEMENTS_23')"></p>
                                                <h4>{{ $t('TEXT_PERSONAL_INFORMATION_10') }}</h4>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_11') }}</td>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_12') }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_13') }}</td>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_14') }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_15') }}</td>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_16') }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_17') }}</td>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_18') }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_19') }}</td>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_20') }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_21') }}</td>
                                                            <td v-html="$t('TEXT_PERSONAL_INFORMATION_22')"></td>
                                                        </tr>
                                                        <tr>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_23') }}</td>
                                                            <td>{{ $t('TEXT_PERSONAL_INFORMATION_24') }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <h3>{{ $t('TEXT_PERSONAL_INFORMATION_25') }}</h3>
                                                <p>{{ $t('TEXT_PERSONAL_INFORMATION_26') }}</p>
                                                <h5>{{ $t('TEXT_REGISTER_AGREEMENTS_24') }}</h5>
                                                <p>{{ $t('TEXT_REGISTER_AGREEMENTS_25') }}</p>
                                                <h5>{{ $t('TEXT_REGISTER_AGREEMENTS_26') }}</h5>
                                                <p>{{ $t('LABEL_HUBSYNCH') }}</p>
                                                <h5>{{ $t('TEXT_REGISTER_AGREEMENTS_27') }}</h5>
                                                <p>{{ $t('TEXT_PERSONAL_INFORMATION_30') }} <br>
                                                    {{ $t('TEXT_PERSONAL_INFORMATION_31') }} <br>
                                                    {{ $t('TEXT_PERSONAL_INFORMATION_32') }} <br>
                                                    {{ $t('TEXT_PERSONAL_INFORMATION_33') }}<br>
                                                    {{ $t('TEXT_PERSONAL_INFORMATION_34') }}
                                                </p>
                                                <h5>4. {{ $t('TEXT_PERSONAL_INFORMATION_35') }}</h5>
                                                <p>{{ $t('TEXT_REGISTER_AGREEMENTS_28') }}</p>
                                                <h3>{{ $t('TEXT_PERSONAL_INFORMATION_39') }}</h3>
                                                <p>{{ $t('TEXT_PERSONAL_INFORMATION_40') }}</p><br>
                                                <h4>{{ $t('TEXT_PERSONAL_INFORMATION_41') }}</h4>
                                                <p>{{ $t('TEXT_PERSONAL_INFORMATION_42') }}<br>
                                                    {{ $t('TEXT_PERSONAL_INFORMATION_43') }}<br>
                                                    {{ $t('TEXT_PERSONAL_INFORMATION_44')
                                                    }}：https://hubsynch.com/contactus/</p>
                                                <h3>６{{ $t('TEXT_PERSONAL_INFORMATION_45') }}</h3>
                                                <p>{{ $t('TEXT_PERSONAL_INFORMATION_46') }}</p>
                                                <ol class="paren">
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_47')"></li>
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_48')"></li>
                                                </ol>
                                                <h3>{{ $t('TEXT_PERSONAL_INFORMATION_49') }}</h3>
                                                <p>{{ $t('TEXT_PERSONAL_INFORMATION_50') }}</p>
                                                <ol>
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_51')"></li>
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_52')"></li>
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_53')"></li>
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_54')"></li>
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_55')"></li>
                                                    <li v-html="$t('TEXT_REGISTER_AGREEMENTS_29')"></li>
                                                </ol>
                                                <h3>{{ $t('TEXT_PERSONAL_INFORMATION_58') }}</h3>
                                                <ol class="paren">
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_59')" </li>
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_60')"></li>
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_61')"></li>
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_62')"></li>
                                                </ol>
                                                <h3>{{ $t('TEXT_REGISTER_AGREEMENTS_30') }}</h3>
                                                <p>{{ $t('TEXT_PERSONAL_INFORMATION_69') }}</p>
                                                <ol class="paren">
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_70')"></li>
                                                    <li>{{ $t('TEXT_PERSONAL_INFORMATION_71') }}<br>
                                                        {{ $t('TEXT_PERSONAL_INFORMATION_72') }}<br>
                                                        ・{{ $t('TEXT_PERSONAL_INFORMATION_73') }}</li>
                                                    <li v-html="$t('TEXT_PERSONAL_INFORMATION_74')"></li>
                                                    <li v-html="$t('TEXT_REGISTER_AGREEMENTS_31')"></li>
                                                </ol>
                                                <p class="right-side" v-html="$t('TEXT_REGISTER_AGREEMENTS_32')"></p>
                                            </div>

                                            <div class="c-btn c-btn--toregister">
                                                <router-link :to="{ name: 'register.verify' }">
                                                    <a href="#">{{ $t('LABEL_AGREE_AND_MOVE') }}</a>
                                                </router-link>
                                            </div>
                                        </div>

                                        <div class="p-agreement__back">
                                            <router-link :to="{ name: 'login' }">
                                                <div class="c-btn c-btn--tologin"><a href="#">{{
                                                        $t('LABEL_BUTTON_TO_LOGIN_PAGE') }}</a></div>
                                            </router-link>
                                        </div>
                                    </section>

                                </div><!-- .bg-box -->

                            </div>
                        </div>
                    </section>


                </div><!-- .l-content -->
            </section><!-- .l-content-area -->

        </div><!-- .l-project-wrap -->

        <!-- footer -->

    </div>
</template>